module.exports = __webpack_public_path__ + "media/images/country_flags/aq-eb662f2d7514765f381369defeef7634.png";